import { Box, Button, Card, CircularProgress, Container, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, InputBase, MenuItem, Paper, Popover, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react'
import { Helmet } from 'react-helmet-async';
import Iconify from 'src/components/iconify';
import { getData, postData, putData, uploadFile } from 'src/webService/webService';
import PaginationComponent from 'src/components/pagination';
import { toast } from 'react-toastify';


const SelfAssignedWebsite = () => {

  const role = sessionStorage.getItem('role');
  const roleType = sessionStorage.getItem('roleType');
  const serviceTeamType = sessionStorage.getItem('serviceTeamType');
  const userId = sessionStorage.getItem('userId');
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(5);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const sessionToken = sessionStorage.getItem("Token");
  const [websiteData, setWebsiteData] = useState([]);
  const [open, setOpen] = useState();
  const [formOpen, setFormOpen] = useState();
  const [details, setDetails] = useState(false);
  const [allUpdates, setAllUpdates] = useState([]);
  const [selectedLeadId, setSelectedLeadId] = useState(null);
  const [selectedWorkUpdateId, setSelectedWorkUpdateId] = useState(null);
  const [view, setView] = useState([]);
  const [selectedLead, setSelectedLead] = useState("");
  const [assignedLeads, setAssignedLeads] = useState([]);
  const descriptionElementRef = useRef(null);
  const [scroll, setScroll] = useState('paper');
  const [dailyData, setDailyData] = useState("");
  const [selectedFiles, setSelectedFiles] = useState({})
  const UserId = sessionStorage.getItem("userId");
  const [fileUpload, setFileUpload] = useState(null);

  const getAllLeads = async (skip = currentPage, limit = 5) => {
    const parmas = {
      page: skip,
      limit: limit
    }
    try {
      console.log("Fetching users...");
      console.log("Token being sent:", sessionToken);

      const response = await getData(`leads/leads/${userId}`, parmas, sessionToken);
      console.log("Response:", response)

      const responseData = response?.data[0]?.paginatedResults || [];

      setWebsiteData(responseData)
      setTotalPages(response.data[0].totalPages);
      setTotalCount(response.data[0].totalCount.totalItems);

    }
    catch (error) {
      console.error("Error fetching users:", error);
    }
  }
  useEffect(() => {
    getAllLeads(currentPage, limit);
  }, [currentPage, limit, roleType]);

  const getAllUpdatesAdmin = async () => {

    const params = {
      page: 1,
      limit: 1000
    }

    try {
      const response = await getData("dailyworkupdates/updates", params, sessionToken);
      console.log("Response Dailyyy Updates:", response)

      const filteredData = response?.data[0]?.paginatedResults?.filter(lead => lead.serviceName === "WebSite Designing");

      console.log("Filtered Data:", filteredData);
      setAllUpdates(filteredData);

    } catch (err) {
      console.error("Error while fetching Website Designing Team:", err);
      toast.error("Failed to load Website Designing Team.");
    }

  }

  const getDailyUpdates = async () => {

    try {
      const response = await getData(`dailyworkupdates/user/${UserId}`, {}, sessionToken);
      console.log("Response Daily Updates:", response)
      const results = response?.data;
      console.log("Results:", results)
      setDailyData(results);

    } catch (err) {
      console.error("Error while fetching Website Designing Team:", err);
      toast.error("Failed to load Website Designing Team.");
    }

  }

  const handleFileUpload = async (fileupload, leadId) => {
    console.log("Fileupload:", fileupload);
    console.log("Is File:", fileupload instanceof File);

    const formDataToSend = new FormData();
    formDataToSend.append("file", fileupload);

    try {
      const response = await uploadFile(`files/upload/${selectedLeadId}`, formDataToSend);
      if (response?.status === 200) {
        toast.success("File uploaded successfully!");
        setFileUpload(response?.data);
        setFormData(prevState => ({
          ...prevState,
          fileupload: response?.data,
        }));
      } else {
        toast.error("File upload failed!");
      }
    } catch (error) {
      console.error("File upload error:", error);
      toast.error("Error uploading file.");
    }
  };
  const postDailyWorkUpdate = async () => {
    debugger;
    try {
      const checkResponse = await getData(`dailyworkupdates/${selectedLeadId}`, {}, sessionToken);
      const existingUpdates = checkResponse?.data?.flatMap(update => update?.websiteDesigningHistory?.map(history => history?.dailyUpdateId)) || [];

      const websiteDesigningHistory = selectedLead?.websiteDesigningHistory?.[0] ||
        selectedLead?.websiteDesigningHistory ||
        {};
      const previousCompleted = websiteDesigningHistory.completedPages || 0;
      const newCompleted = parseInt(formData.completedPages, 10) || 0;
      const totalCompleted = previousCompleted + newCompleted;

      const websiteType = selectedLead?.websiteDesigningHistory?.[0]?.websiteType ||
        selectedLead?.websiteDesigningHistory?.websiteType ||
        '';

      const totalPages = selectedLead?.websiteDesigningHistory?.[0]?.totalPages ||
        selectedLead?.websiteDesigningHistory?.totalPages ||
        '';

      const amount = selectedLead?.websiteDesigningHistory?.[0]?.amount ||
        selectedLead?.websiteDesigningHistory?.amount ||
        '';
      const assignedTo = selectedLead?.websiteDesigningHistory?.[0]?.assignedTo ||
        selectedLead?.websiteDesigningHistory?.assignedTo ||
        '';

      const payLoad = {
        completedPages: totalCompleted,
        fileUpload: fileUpload,
        amount,
        assignedTo,
        progressPercentage: formData.progressPercentage,
        status: formData.status,
        contentStatus: formData.contentStatus,
        comments: formData.comments,
        websiteType: websiteType,
        totalPages: totalPages,
        serviceName: "WebSite Designing",
        leadId: selectedLeadId,
        userId: UserId
      };

      let response;

      if (existingUpdates.length === 0) {
        // POST new update if none exists
        response = await postData('dailyworkupdates', payLoad, sessionToken);
      } else {
        // PUT update existing record
        const updateId = existingUpdates[existingUpdates.length - 1]; // Get first update's ID
        response = await putData(`dailyworkupdates/dailyworkupdates/${updateId}`, payLoad, sessionToken);
      }

      if (response?.status === 200) {
        toast.success("Daily Work Updated Successfully!");
        handleClose();
        getDailyUpdates();
      } else {
        throw new Error(response?.message || "Failed to update Daily Work.");
      }

    } catch (error) {
      console.error("Error:", error);
      toast.error(error.message);
    }
  }
  const [formData, setFormData] = useState({
    completedPages: '',
    fileUpload: "",
    progressPercentage: '',
    status: "",
    contentStatus: '',
    comments: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };
  const handleOpenDialog = async () => {
    await getAllUpdatesAdmin();
    setDetails(true);
    handleCloseMenu();
  };

  const handleCloseDialog = () => {
    setDetails(false);
  };

  const handleOpen = async () => {
    setFormOpen(true);
    handleCloseMenu();
  }

  const handleClose = () => {
    setFormOpen(false)
  }

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleOpenMenu = (event, task, id, workUpdateId) => {
    let lead;

    if (task && typeof task === 'object') {
      lead = task;
      setSelectedLead(lead);
    }

    else {
      lead = assignedLeads.find((data) => data._id === id);
      setSelectedLead(lead);
    }

    if (event?.currentTarget) {
      setOpen(event.currentTarget);
      setSelectedLeadId(id);
      setSelectedWorkUpdateId(workUpdateId);
      setView(lead || task);
    }
  };

  const handleFileChange = (event, leadId) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFiles(prev => ({ ...prev, [leadId]: file }));
      handleFileUpload(file, leadId);
    }
  };

  const handleLimitChange = (event) => {
    setCurrentPage(1);
    if (currentPage === 1) {
      setLimit(event.target.value)
      getAllLeads(1, event.target.value)
    }
    else {
      setCurrentPage(1);
      setLimit(event.target.value);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
      getAllLeads(currentPage - 1, limit);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
      getAllLeads(currentPage + 1, limit);
    }
  };
  return (
    <>
      <Helmet>
        <title>Self Assigned Website</title>
      </Helmet>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Self Assigned Website
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "start",
                backgroundColor: "white",
                borderRadius: "15px",
                padding: "4px 12px",
                boxShadow: 1,
                marginRight: "20px"
              }}
            >
              <Iconify icon="eva:search-fill" />
              <InputBase
                placeholder="Search"
                sx={{ marginLeft: "8px" }}
              />
            </Box>
          </Box>
        </Stack>
        <Card sx={{ padding: 2, boxShadow: 3, backgroundColor: "#fff" }}>
          <TableContainer component={Paper} sx={{ boxShadow: "none", backgroundColor: "transparent", maxHeight: 350 }}>
            <Table>
              <TableHead>
                <TableCell>S.No</TableCell>
                <TableCell>Lead</TableCell>
                <TableCell>Contact</TableCell>
                <TableCell>Website Type</TableCell>
                <TableCell>Assigned Tasks</TableCell>
                <TableCell>Assigned Pages</TableCell>
                <TableCell>Deadline</TableCell>
                <TableCell>Completed Pages</TableCell>
                {/* <TableCell>Requirement</TableCell> */}
                <TableCell>Status</TableCell>
                <TableCell></TableCell>
              </TableHead>
              <TableBody>
                {websiteData?.map((service, index) => {
                  return (
                    <TableRow key={service._id}>
                      <TableCell>{(index + 1)}</TableCell>
                      <TableCell>
                        {service.name}
                      </TableCell>
                      <TableCell>
                        {service.phone}
                      </TableCell>
                      <TableCell>
                        {service?.websiteDesigningHistory[0]?.websiteType}
                      </TableCell>
                      <TableCell>{service?.currentWork?.noOfPosters}</TableCell>
                      <TableCell>{service?.currentWork?.comments}</TableCell>
                      <TableCell>{service?.currentWork !== null ? new Date(service?.currentWork?.deadline).toLocaleDateString() : "-"}</TableCell>
                      <TableCell>
                        {service?.websiteDesigningHistory[0]?.completedPages} / {service?.websiteDesigningHistory[0]?.totalPages}
                      </TableCell>
                      {/* <TableCell>
                        {service?.websiteDesigningHistory[0]?.requirements}
                      </TableCell> */}
                      <TableCell align="center">
                        <Box position="relative" display="inline-flex">
                          <CircularProgress
                            variant="determinate"
                            value={service?.websiteDesigningHistory[0]?.progressPercentage}
                          />
                          <Box
                            top={0}
                            left={0}
                            bottom={0}
                            right={0}
                            position="absolute"
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                          >
                            <Typography variant="caption" component="div" color="text.secondary">
                              {typeof service?.websiteDesigningHistory[0]?.progressPercentage === 'number'
                                ? `${Math.round(service.websiteDesigningHistory[0].progressPercentage)}%`
                                : '0%'}
                            </Typography>
                          </Box>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Iconify
                          icon="material-symbols-light:more-vert"
                          sx={{ margin: "auto" }}
                          onClick={(event) => {
                            console.log('service object:', service);
                            handleOpenMenu(event, service, service._id, service?.websiteDesigningHistory[0]?.dailyUpdateId);
                          }}
                        />
                      </TableCell>
                    </TableRow>
                  )
                })}
              </TableBody>
            </Table>
          </TableContainer>
          {/* <PaginationComponent
            name={"Service"}
            totalcount={totalCount}
            limit={limit}
            handleLimitChange={handleLimitChange}
            handlePrevPage={handlePrevPage}
            handleNextPage={handleNextPage}
            currentPage={currentPage}
            totalPages={totalPages}
          /> */}
        </Card>
        <Popover
          open={Boolean(open)}
          anchorEl={open}
          onClose={handleCloseMenu}
          anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          PaperProps={{
            sx: {
              p: 1,
              width: 140,
              '& .MuiMenuItem-root': {
                px: 1,
                typography: 'body2',
                borderRadius: 0.75,
              },
            },
          }}
        >
          <MenuItem onClick={handleOpenDialog}>
            <Iconify icon={'material-symbols:visibility'} sx={{ mr: 2 }} />
            View
          </MenuItem>
          <MenuItem onClick={handleOpen}>
            <Iconify icon={'eva:edit-fill'} sx={{ mr: 1 }} />
            Work Update
          </MenuItem>
        </Popover>
        <Dialog
          open={details}
          onClose={handleCloseDialog}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title">
            <Typography variant='h5' component="div" sx={{ fontWeight: "bold" }}>
              Daily Work Updates
            </Typography>
          </DialogTitle>
          <DialogContent dividers={scroll === 'paper'}>
            <DialogContentText
              id="scroll-dialog-description"
              ref={descriptionElementRef}
              component="div"
            >
              {!view || Object.keys(view).length === 0 ? (
                <Box sx={{ p: 3, textAlign: 'center' }}>
                  <Typography variant='h6' color="text.secondary">No data found</Typography>
                </Box>
              ) : (
                <Box sx={{ p: 1 }}>
                  <Paper
                    elevation={3} sx={{
                      p: 2,
                      backgroundColor: '#ffffff',
                      borderRadius: 2,
                      boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
                      borderLeft: '5px solid #1976d2'
                    }}
                  >
                    <Grid container spacing={2}>
                      <Grid item xs={12} id="paddingTop">
                        <Typography variant="h6" sx={{ color: '#333' }}>
                          Project Details
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6} id="paddingTop">
                        <Typography variant="body1">
                          Name: {view?.name}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6} id="paddingTop">
                        <Typography variant="body1">
                          Requirements: {view?.websiteDesigningHistory[0]?.requirements}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6} id="paddingTop">
                        <Typography variant="body1">
                          Deadline: {new Date(view?.websiteDesigningHistory[0]?.deadline).toLocaleDateString()}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6} id="paddingTop">
                        <Typography variant="body1">
                          Status: <Typography component="span" sx={{
                            fontWeight: 'bold',
                            color: view?.websiteDesigningHistory[0]?.status === 'Completed' ? 'success.main' :
                              view?.websiteDesigningHistory[0]?.status === 'In Progress' ? 'warning.main' : 'error.main'
                          }}>
                            {view?.websiteDesigningHistory[0]?.status}
                          </Typography>
                        </Typography>
                      </Grid>
                      <Grid item xs={12} id="paddingTop">
                        <Typography variant="body1">
                          Website Type: {view?.websiteDesigningHistory[0]?.websiteType}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} id="paddingTop">
                        <Typography variant="h6" sx={{ color: '#333' }}>
                          Task Progress
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6} id="paddingTop">
                        <Typography variant="body1">
                          Completed Pages: {view?.websiteDesigningHistory[0]?.completedPages}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6} id="paddingTop">
                        <Typography variant="body1">
                          Total Pages: {view?.websiteDesigningHistory[0]?.totalPages}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} id="paddingTop">
                        <Typography variant="body1">
                          Progress: <Typography component="span" sx={{ fontWeight: 'bold', color: '#007bff' }}>
                            {view?.websiteDesigningHistory[0]?.progressPercentage}%
                          </Typography>
                        </Typography>
                      </Grid>

                      {view?.[0]?.websiteDesigningHistory[0]?.comments && (
                        <Grid item xs={12} id="paddingTop">
                          <Typography variant="h6" sx={{ mt: 2, mb: 1, color: '#333' }}>
                            Comments
                          </Typography>
                          <Typography variant="body2" sx={{ fontStyle: 'italic', color: 'text.secondary' }}>
                            {view?.[0]?.websiteDesigningHistory[0]?.comments}
                          </Typography>
                        </Grid>
                      )}

                      <Grid item xs={12} id="paddingTop">
                        <Typography variant="h6" sx={{ color: '#333' }}>
                          Timestamps
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6} id="paddingTop">
                        <Typography variant="body2" color="text.secondary">
                          Created: {new Date(view?.createdAt).toLocaleString()}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6} id="paddingTop">
                        <Typography variant="body2" color="text.secondary">
                          Updated: {new Date(view?.updatedAt).toLocaleString()}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Paper>
                </Box>
              )}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDialog}>Close</Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={formOpen}
          onClose={handleClose}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title">Daily Work Update!</DialogTitle>
          <DialogContent dividers={scroll === 'paper'}>
            <DialogContentText
              id="scroll-dialog-description"
              ref={descriptionElementRef}
            >
              <TextField
                margin="dense"
                label="Completed Pages"
                name="completedPages"
                value={formData.completedPages}
                onChange={handleChange}
                type="number"
                fullWidth
              />

              <TextField
                margin="dense"
                label="Status"
                name="status"
                value={formData.status}
                onChange={handleChange}
                select
                fullWidth
              >
                <MenuItem value="Pending">Pending</MenuItem>
                <MenuItem value="In Progress">In Progress</MenuItem>
                <MenuItem value="Completed">Completed</MenuItem>
              </TextField>

              <TextField
                margin="dense"
                label="Comments"
                name="comments"
                value={formData.comments}
                onChange={handleChange}
                multiline
                fullWidth
              />
              <TextField
                margin='dense'
                type='file'
                hidden
                label="Upload File"
                fullWidth
                InputLabelProps={{ shrink: true }}
                onChange={(e) => handleFileChange(e)}
              >
              </TextField>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button onClick={postDailyWorkUpdate}>Submit</Button>
          </DialogActions>
        </Dialog>
      </Container>

    </>
  )
}

export default SelfAssignedWebsite;